export const environment = {
  production: true,
  buildId: '2610016300717911',
  configFile: 'config.json',
};
